// extracted by mini-css-extract-plugin
export default {"panel":"popup_panel__XKcSA","overlay":"popup_overlay__eSg3s","close":"popup_close__-m5Vi"};